export const tealiumConstants = {
  pageCategory: 'rx mdp',
  pageNameHeader: 'rx: mdp: header',
  pageNameSideBar: 'rx: mdp: sidebar',
  pageNameHome:	'rx: mdp: home main page',
  cvsPharmacy: {
    link_name: 'Custom:mdp:header:cvs pharmacy back link',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  },
  signOut: {
    link_name: 'Custom:mdp:header:sign out link',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  },
  homePageView: {
    page_name:	'rx: mdp: home main page',
    page_category: 'rx mdp',
    enrollment_type: 'rx: mdp enrollment new'
  },
  signInEvent: {
    email_id: '',
    login_method: 'standard sign in',
    login_attempts: '+1',
    link_name: 'Custom:Sign In Submit',
    link_trackvars: 'events,eVar33,eVar34,eVar91',
    link_trackevents: 'event22,event11',
    event_name: 'event11,event22'
  },
  pageNameVod:	'rx: mdp: orders',
  pageNameVmd:	'rx: mdp: medication details',
  pageNameVodHistory:	'rx: mdp: orders history',
  viewOrderDetails: {
    link_name: 'Custom:mdp:dashboard:view order details',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  },
  viewMedicationDetails: {
    link_name: 'Custom:mdp:dashboard:order details: view medication details',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  },
  editMedicationDetails: {
    link_name: 'Custom:mdp:dashboard:order details:add or remove medications',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  },
  viewOrderHistory: {
    link_name: 'Custom:mdp:dashboard:view order history',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  },
  pageNameContactUs:	'rx: mdp: contact us',
  contactUs: {
    link_name: 'Custom:mdp:dashboard:contact us card',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  },
  faq: {
    link_name: 'Custom:mdp:dashboard:faq modal',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  },
  accessMdp: {
    link_name: 'Custom:mdp:access multi-dose packs',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  },
  syncPlanView: {
    page_name:	'rx:mdp:dashboard:syncplan',
    page_category: 'rx mdp'
  },
  copayModal: {
    link_name: 'Custom:mdp:dashboard:syncplan:copay modal',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  },
  pageNameRefill:	'rx: mdp: autofill',
  refill: {
    link_name: 'Custom:mdp:dashboard:activate autofill',
    link_trackvars: 'rx mdp',
    link_trackevents: 'event60'
  },
  refillView: {
    internal_campaign_id:	'rx:mdp:activate autofill banner',
    event_name: 'event51'
  },
  pageNameProgramEnrollment:	'rx:mdp:dashboard:enroll in simpledose',
  programEnrollment: {
    link_name: 'Custom:mdp:dashboard:enroll in simpledose link',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  },
  approveExplained: {
    link_name: 'Custom:mdp:dashboard:approve on time modal',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  },
  manageAnotherAccount: {
    link_name: 'Custom: rx:mdp:dashboard: manage another account link',
    link_trackvars: 'events',
    link_trackevents: 'event00'
  }
};
